import React, { useEffect, useState } from "react";
import { useParams, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { UserOutlined } from "@ant-design/icons";
import Sidebar from "./sidebar/Sidebar";
import Header from "./Header";
import { fetchRoles } from "slices/roleSlice";
import { DEFAULT_LANDING_PAGES, DEFAULT_DASHBOARD_FALLBACK } from "shared/constants/Constants";
import { useAgentAccountDetails } from "shared/hooks/common";
import useSessionLogout from "shared/hooks/useSessionLogout";
import RightArrowPoint from "components/ui/icons/svgs/RightArrowPoint";

/** When true, the desktop sidebar starts collapsed. Only affects the desktop sidebar, not the mobile header menu. */
const DESKTOP_SIDEBAR_COLLAPSED_BY_DEFAULT = true;

function AppLayout() {
  const { table } = useParams();
  const dispatch = useDispatch();
  const { agentRole, agentName, agentEmail } = useAgentAccountDetails();
  const logoutSession = useSessionLogout();
  // Current page comes from URL (table = segment after /dashboard). Prefer useParams().table in children when only the current page is needed.
  const initialTable =
    table ?? (agentRole && DEFAULT_LANDING_PAGES[agentRole]) ?? DEFAULT_DASHBOARD_FALLBACK;
  const [sidebarListClick, setSidebarListClick] = useState(initialTable);
  const [collapseSidebar, setCollapseSidebar] = useState(DESKTOP_SIDEBAR_COLLAPSED_BY_DEFAULT);

  useEffect(() => {
    dispatch(fetchRoles());
  }, [dispatch]);

  useEffect(() => {
    if (table) setSidebarListClick(table);
  }, [table]);

  return (
    <>
      <div className="  fixed  tables-dashboards-containers">
        <div
          onClick={() => {
            setCollapseSidebar(false);
          }}
          className="sidebar-dashboard-container sidebar-dashboard-container--animated"
          style={{
            width: collapseSidebar ? "4vw" : "calc(225/ 1440 * 100vw)",
            minWidth: collapseSidebar ? "60px" : "calc(225/ 1440 * 100vw)",
            // minWidth:'60px'
            // ...(collapseSidebar && {
            //   width: "4vw",
            //   paddingRight: "1%",
            //   paddingLeft: "1%",
            //   // padding: "0%",
            //   minWidth: "50px",
            //   justifyContent: "center",
            // }),
          }}
        >
          <div
            onClick={(e) => {
              e.stopPropagation();
              setCollapseSidebar(!collapseSidebar);
            }}
            className="sidebar-dashboard-container-close-btn"
            style={{
              transform: collapseSidebar
                ? "translateX(50%) rotate(0deg)"
                : "translateX(50%) rotate(180deg)",
            }}
          >
            <RightArrowPoint size={"20"} />
          </div>
          <Sidebar
            collapseSidebar={collapseSidebar}
            sidebarListClick={sidebarListClick}
            setSidebarListClick={setSidebarListClick}
          />
        </div>
        <div
          className="applayout-dashboards-container applayout-dashboards-container--animated"
          style={{
            width: collapseSidebar ? "calc(100% - 60px)" : "calc(100vw - 15.62vw)",
          }}
        >
          <div className="flex-1 h-[10vh]">
            <div className={`md:hidden`}>
              {
                <Header
                  className={`w-full sticky top-0 z-10 `}
                  avatarIcon={<UserOutlined />}
                  role={agentRole}
                  userName={agentName}
                  email={agentEmail}
                  avatarClass="bg-[#87d068]"
                  sidebarListClick={sidebarListClick}
                  setSidebarListClick={setSidebarListClick}
                  handleLogout={logoutSession}
                />
              }
            </div>
            <div
              className={`h-auto ${agentRole !== "parking" ? " flex-1  " : ""}  bg-transparent  `}
            >
              <Outlet context={{ agentRole, sidebarListClick, setSidebarListClick }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AppLayout;
